// extracted by mini-css-extract-plugin
export default {"errorIcon":"componentWithTooltip_errorIcon__gkdMP","errorMsg":"componentWithTooltip_errorMsg__JXRsc"};